module.exports = __webpack_public_path__ + "static/media/Header_Image_002_Mobile.d57ea30e.png";